export const isValidZip = (value: string): string | boolean => {
  const pattern = /^\d{5}$/;
  return value?.match(pattern) !== null || "Must be 5 digits";
};

export const isValidZipCIAM = (value: string): string | boolean => {
  const pattern = /^\d{5}$/;
  return value?.match(pattern) !== null || "ZIP code is required";
};
